import React, { useState, useEffect } from 'react';
import Logo from './header-parts/Logo';
import NotificationDropdown from './header-parts/NotificationDropdown';
import ProfileDropdown from './header-parts/ProfileDropdown';
import { Link } from "react-router-dom";

export default function SurveyListHeader() {
    const [addClass, setAddClass] = useState(false);
    // Function to toggle the class on the body element
    const toggleBodyClass = () => {
        setAddClass(!addClass);
    };

    // Use useEffect to add or remove the class when addClass changes
    useEffect(() => {
        if (addClass) {
            document.body.classList.add('sidebar-open');
        } else {
            document.body.classList.remove('sidebar-open');
        }

        // Clean up the effect when the component unmounts
        return () => {
            document.body.classList.remove('sidebar-open');
        };
    }, [addClass]);
    return (
        <>
            <div className='site-header border-bottom'>
                <div className="row align-items-center">
                    <div className="col-md-6 col-8">
                        <Logo />
                    </div>
                    <div className="col-md-6 col-4">
                        <div className="right-menu-wrap align-items-center d-flex justify-content-end">
                            {/* <NotificationDropdown /> */}
                            <ProfileDropdown />
                            <button className="sideb-toggle d-lg-none ms-3" onClick={toggleBodyClass}>
                                <span className="hamburger hamburger-1" />
                                <span className="hamburger hamburger-2" />
                                <span className="hamburger hamburger-3" />
                            </button>
                        </div>
                    </div>
                </div>
            </div >
            <div className="body-overlay" onClick={toggleBodyClass}/>

        </>
    )
}
